export const HoldingRegisterAssetsBaseFilter = {
  Description: "description" as const,
  IsDeleted: "isDeleted" as const,
  Depreciates: "depreciates" as const,
  IsActive: "isActive" as const,
  Snapshot: "snapshot" as const,
  StartMonth: "startMonth" as const,
  TerminationMonth: "terminationMonth" as const,
  HasVouchers: "hasVouchers" as const,
  SerialNumber: "serialNumber" as const,
}

export const HoldingRegisterFilter = {
  AssetAccountName: "assetAccountName" as const,
  AssetAccountNumber: "assetAccountNumber" as const,
  DepreciationAccountName: "depreciationAccountName" as const,
  DepreciationAccountNumber: "depreciationAccountNumber" as const,
}

